/**
 * Generated from hh_ch1_72dpi_p03-04-05.fla
 */
export function hh_ch1_72dpi_p030405(this: Ihh_ch1_72dpi_p030405) {
	const face = this.face;
	if (!face[0] && face.elementFactory) {
		face[0] = face.elementFactory(0,undefined);
	}
	if (face[0]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1.call(face[0] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1);
		face[0].x = 835.25;
		face[0].y = 263;
		face[0].width = 175.50;
		face[0].height = 198.00;
		face[0].alpha = 1;
		if (face[0].onLayout) face[0].onLayout();
	}
	if (!face[1] && face.elementFactory) {
		face[1] = face.elementFactory(1,undefined);
	}
	if (face[1]) {
		hh_ch1_72dpi_p030405_ch1_p03_hollyface2.call(face[1] as Ihh_ch1_72dpi_p030405_ch1_p03_hollyface2);
		face[1].x = 835.25;
		face[1].y = 263;
		face[1].width = 175.50;
		face[1].height = 198.00;
		face[1].alpha = 1;
		if (face[1].onLayout) face[1].onLayout();
	}
	if (!face[2] && face.elementFactory) {
		face[2] = face.elementFactory(2,undefined);
	}
	if (face[2]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3.call(face[2] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3);
		face[2].x = 835.25;
		face[2].y = 263;
		face[2].width = 175.50;
		face[2].height = 198.00;
		face[2].alpha = 1;
		if (face[2].onLayout) face[2].onLayout();
	}
	const ambience = this.ambience;
	if (!ambience[0] && ambience.elementFactory) {
		ambience[0] = ambience.elementFactory(0,undefined);
	}
	if (ambience[0]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80.call(ambience[0] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80);
		ambience[0].x = 832;
		ambience[0].y = 384;
		ambience[0].width = 1664.00;
		ambience[0].height = 768.00;
		ambience[0].alpha = 1;
		if (ambience[0].onLayout) ambience[0].onLayout();
	}
	if (!ambience[1] && ambience.elementFactory) {
		ambience[1] = ambience.elementFactory(1,undefined);
	}
	if (ambience[1]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81.call(ambience[1] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81);
		ambience[1].x = 0;
		ambience[1].y = 0;
		ambience[1].width = 1664.00;
		ambience[1].height = 768.00;
		ambience[1].alpha = 0;
		if (ambience[1].onLayout) ambience[1].onLayout();
	}
	const frame = this.frame;
	if (!frame[0] && frame.elementFactory) {
		frame[0] = frame.elementFactory(0,undefined);
	}
	if (frame[0]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135.call(frame[0] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135);
		frame[0].x = 1533.25;
		frame[0].y = 384;
		frame[0].width = 261.50;
		frame[0].height = 768.00;
		frame[0].alpha = 1;
		if (frame[0].onLayout) frame[0].onLayout();
	}
	if (!frame[1] && frame.elementFactory) {
		frame[1] = frame.elementFactory(1,undefined);
	}
	if (frame[1]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy.call(frame[1] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy);
		frame[1].x = 114.75;
		frame[1].y = 384;
		frame[1].width = 261.50;
		frame[1].height = 768.00;
		frame[1].alpha = 1;
		if (frame[1].onLayout) frame[1].onLayout();
	}
	if (!frame[2] && frame.elementFactory) {
		frame[2] = frame.elementFactory(2,undefined);
	}
	if (frame[2]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144.call(frame[2] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144);
		frame[2].x = 832;
		frame[2].y = 438.5;
		frame[2].width = 1664.00;
		frame[2].height = 564.00;
		frame[2].alpha = 1;
		if (frame[2].onLayout) frame[2].onLayout();
	}
	if (!frame[3] && frame.elementFactory) {
		frame[3] = frame.elementFactory(3,undefined);
	}
	if (frame[3]) {
		hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747.call(frame[3] as Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747);
		frame[3].x = 40;
		frame[3].y = 437.5;
		frame[3].width = 80.00;
		frame[3].height = 246.00;
		frame[3].alpha = 1;
		if (frame[3].onLayout) frame[3].onLayout();
	}
	const background = this.background;
	hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_background.call(this.background);
	background.x = 0;
	background.y = 0;
	background.width = 1664.00;
	background.height = 768.00;
	background.alpha = 1.00;
	if (background.onLayout) background.onLayout();
	const bedBottom = this.bedBottom;
	hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedbottom.call(this.bedBottom);
	bedBottom.x = 828.5;
	bedBottom.y = 376.5;
	bedBottom.width = 1324.00;
	bedBottom.height = 783.00;
	bedBottom.alpha = 1.00;
	if (bedBottom.onLayout) bedBottom.onLayout();
	const hollyBase = this.hollyBase;
	hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollybase.call(this.hollyBase);
	hollyBase.x = 824.75;
	hollyBase.y = 570.5;
	hollyBase.width = 616.50;
	hollyBase.height = 655.50;
	hollyBase.alpha = 1.00;
	if (hollyBase.onLayout) hollyBase.onLayout();
	const bedTop = this.bedTop;
	hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedtop.call(this.bedTop);
	bedTop.x = 807.75;
	bedTop.y = 646.25;
	bedTop.width = 1131.50;
	bedTop.height = 243.50;
	bedTop.alpha = 1.00;
	if (bedTop.onLayout) bedTop.onLayout();
	const light = this.light;
	hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLight.call(this.light);
	light.x = 0;
	light.y = 0;
	light.width = 1664.00;
	light.height = 768.00;
	light.alpha = 0.28;
	if (light.onLayout) light.onLayout();
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_background(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_background) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_background.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedbottom(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedbottom) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_bedbottom", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollybase(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollybase) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_hollybase.png", 0.500, 0.699);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_hollyface1", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_ch1_p03_hollyface2(this: Ihh_ch1_72dpi_p030405_ch1_p03_hollyface2) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_hollyface2", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_hollyface3", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedtop(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedtop) {
	if (this.setLayoutTexture) this.setLayoutTexture("ch1_p03_bedtop", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer80", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer81.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLight(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLight) {
	if (this.setLayoutTexture) this.setLayoutTexture("Light.png", 0.000, 0.000);
	if (this.setBlendMode) this.setBlendMode("overlay");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer135", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer135copy", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer144", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("multiply");
	return this;
}
function hh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747(this: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747) {
	if (this.setLayoutTexture) this.setLayoutTexture("Layer747", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
interface Ihh_ch1_72dpi_p030405Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ihh_ch1_72dpi_p030405Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ihh_ch1_72dpi_p030405Sprite extends Ihh_ch1_72dpi_p030405Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ihh_ch1_72dpi_p030405Text extends Ihh_ch1_72dpi_p030405Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ihh_ch1_72dpi_p030405Polygon extends Array<number> {
}
interface Ihh_ch1_72dpi_p030405 {
	readonly face: Ihh_ch1_72dpi_p030405Array<Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1|Ihh_ch1_72dpi_p030405_ch1_p03_hollyface2|Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3>;
	readonly ambience: Ihh_ch1_72dpi_p030405Array<Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80|Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81>;
	readonly frame: Ihh_ch1_72dpi_p030405Array<Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135|Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy|Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144|Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747>;
	readonly background: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_background;
	readonly bedBottom: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedbottom;
	readonly hollyBase: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollybase;
	readonly bedTop: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedtop;
	readonly light: Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLight;
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_background extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedbottom extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollybase extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface1 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_ch1_p03_hollyface2 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_hollyface3 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_bedtop extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer80 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLayer81 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_ambienceLight extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer135copy extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer144 extends Ihh_ch1_72dpi_p030405Sprite {
}
interface Ihh_ch1_72dpi_p030405_hh_ch1_72dpi_p030405psdAssetP3P4P5ch1_p03_wcframeLayer747 extends Ihh_ch1_72dpi_p030405Sprite {
}
